<template>
	<app-page>
		<app-heading title="Templates">
			<template v-slot:left>
				<app-button v-if="$ravello.can('websitetemplate.post')"
					class="d-none d-sm-inline-flex"
					color="success"
					outlined
					small
					:to="{ name: 'website-template', params: { template: 'new' } }"
				>Add Template</app-button>
			</template>
		</app-heading>
		<app-row>
			<app-cell>
				<app-data-table
					:items="websites"
					:headers="headers"
					:total="count"
					:refresh.sync="refresh"
					@update="fetchWebsites"
				>
					<template v-slot:actions="{ item }">
						<app-button
							v-if="$ravello.can('websitetemplate.get')"
							color="secondary"
							:to="{ name: 'website-template-namespaces', params: { template: item._id } }"
							table
						>
							Manage
						</app-button>
						<app-button
							v-if="$ravello.can('websitetemplate.put')"
							color="secondary"
							:to="{ name: 'website-template', params: { template: item._id } }"
							icon="fa-pencil-alt"
							table
						>
							Edit
						</app-button>
						<app-button-confirm
							v-if="$ravello.can('websitetemplate.delete')"
							color="error"
							icon="fa-trash"
							table
							label-confirm="Remove"
							:description="`Are you sure you want to remove template <b>${item.name}</b>?`"
							title="Remove Website"
							@click="onDelete(item._id)"
						>
							Remove
						</app-button-confirm>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
		<app-floating-button
			class="d-inline-flex d-sm-none"
			:to="{ name: 'website-template', params: { template: 'new' } }"
			color="success"
			icon="fa-plus"
		/>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			websites: [],
			count: -1,
			refresh: false,
			headers: [{
				text: 'Name',
				value: 'name',
				sortable: true,
			}, {
				text: 'Slug',
				value: 'slug',
				sortable: true,
			}, {
				text: 'Locales',
				value: 'locales',
				sortable: false,
				format: 'locales',
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchWebsites(pagination) {
			const request = this.$ravello.graphql('websitetemplates')
				.fromPagination(pagination)
				.fields(['_id', 'name', 'slug', 'locales'])

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.websites = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
